import React from "react";

const Loading = (props) => {
	return <React.Fragment>A carregar...</React.Fragment>;
};

export default Loading;
